import { Skeleton } from '@mui/material';

import Typography from '../../../../../../components/Typography';

export interface PublishedPollTitleSkeletonProps {
  className?: string;
}

const PublishedPollTitleSkeleton = ({ className }: PublishedPollTitleSkeletonProps) => {
  return (
    <Typography variant="h4Medium" color="common.black" className={className}>
      <Skeleton variant="text" width="100%" />
    </Typography>
  );
};
export default PublishedPollTitleSkeleton;
